export var Size = {
  xs: 16,
  s: 20,
  m: 24,
  l: 32
};